<section class="video-panel" *ngIf="videoData">
  <div class="video-panel__content">
    <button (click)="open()" class="video-panel__thumbnail" [ngClass]="{ 'video-panel__thumbnail-small' : !showFullSize }"
      *ngIf="videoData">
      <div class="video-panel__thumbnail-img">
        <app-picture [data]="videoData.thumbnail"></app-picture>
        <div class="video-panel__thumbnail-img-play">
          <div *ngIf="videoData.videoTitle"
              class="video-panel__thumbnail-img-play-title">
            {{ videoData.videoTitle }}
          </div>
        </div>
      </div>
    </button>

    <div *ngIf="videoData.title.value || videoData.description.value"
         class="video-panel__info">
      <h2 *ngIf="videoData.title.value" class="video-panel__info--title">{{ videoData.title.value }}</h2>
      <div *ngIf="videoData.description.value" class="video-panel__info--description" [innerHTML]="videoData.description.value | safe"></div>
    </div>

    <app-modal-video *ngIf="isShow" [data]="videoData" [isShow]="isShow" (close)="close()"></app-modal-video>
  </div>
</section>
